import React from "react";
import DOMPurify from "dompurify";

class SafeHtmlElement extends React.Component {
    constructor(props) {
        super(props);
        this.elementRef = React.createRef();
    }

    componentDidMount() {
        if (this.elementRef.current) {
            this.elementRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.html !== this.props.html && this.elementRef.current) {
            this.elementRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
        }
    }

    render() {
        return React.createElement(this.props.tagName || 'div', {
            ...this.props.elementProps,
            ref: this.elementRef
        });
    }
}

export default class Element extends React.Component {
    render() {
        const { data, tagName, ...baseProps } = this.props;

        if (!data && !this.props.children) {
            return null;
        }

        var props = this.buildProps(baseProps, data || {});
        const hasChildren = !!this.props.children;
        const isStringData = typeof (data) == 'string';
        const html = hasChildren ? null : (isStringData ? data : (data || {}).html);

        if (props.href && html !== null && html !== undefined) {
            return <SafeHtmlElement tagName="a" elementProps={props} html={html} />;
        }

        if (props.href) {
            return (<a {...props}>{this.props.children}</a>);
        }

        if (tagName && html !== null && html !== undefined) {
            return <SafeHtmlElement tagName={tagName} elementProps={props} html={html} />;
        }

        if (tagName) {
            return React.createElement(tagName, props, this.props.children);
        }

        if (html !== null && html !== undefined) {
            return <SafeHtmlElement elementProps={props} html={html} />;
        }

        return (<div {...props}>{this.props.children}</div>);
    }

    buildProps(baseProps, data) {
        const isStringData = typeof (data) == 'string';

        const commonProps = {
            style: data.style,
            className: ((baseProps.className || '') + ' ' + (data.className || '')).trim()
        }

        if (isStringData) {
            return { ...baseProps, ...commonProps };
        }

        const datasetProps = {};

        if (data.dataset) {
            for (var key in data.dataset) {
                const attr = this.parseDataSetAttr(key);
                datasetProps[attr] = data.dataset[key];
            }
        }

        if (!data.href) {
            return { ...baseProps, ...commonProps, ...datasetProps };
        }

        const linkProps = {
            href: data.href,
            target: data.target || ((data.href || '').startsWith('http') ? '_blank' : undefined),
        }

        return {
            ...baseProps,
            ...commonProps,
            ...datasetProps,
            ...linkProps
        };
    }

    parseDataSetAttr(camelString) {
        const upperChars = camelString.match(/([A-Z])/g);

        var str = camelString;
        if (upperChars) {
            for (var i = 0, n = upperChars.length; i < n; i++) {
                str = str.replace(new RegExp(upperChars[i]), '-' + upperChars[i].toLowerCase());
            }
        }

        return 'data-' + str;
    };
}